import React, { createContext, useContext } from 'react';

const ConfigContext = createContext({ 
  storeSettings: { logoType: 'square' },
  Cart: {},
  Navbar: {},
  Products: {},
  Footer: {}
});

export const ConfigProvider = ConfigContext.Provider;
 
export function useConfig() {
  return useContext(ConfigContext);
} 